import { useMutation, useQuery, useQueryClient } from '@tanstack/react-query';
import { useOrganization } from '@clerk/clerk-react';
import {
  fetchEngagement,
  fetchMyEngagements,
  saveOutsourcing,
  saveStaffing,
} from '../api/verifierEngagementApi';

const listKey = (orgId) => ['verifier-engagements', orgId];
const oneKey = (orgId, id) => ['verifier-engagement', orgId, id];

export function useMyEngagements() {
  const { organization } = useOrganization();
  return useQuery({
    queryKey: listKey(organization?.id),
    queryFn: fetchMyEngagements,
    enabled: organization?.publicMetadata?.type === 'verifier',
  });
}

export function useEngagement(id) {
  const { organization } = useOrganization();
  return useQuery({
    queryKey: oneKey(organization?.id, id),
    queryFn: () => fetchEngagement(id),
    enabled: Boolean(id) && organization?.publicMetadata?.type === 'verifier',
    retry: false,
  });
}

function useEngagementMutation(id, fn) {
  const { organization } = useOrganization();
  const queryClient = useQueryClient();
  return useMutation({
    mutationFn: fn,
    onSuccess: () => {
      queryClient.invalidateQueries({ queryKey: oneKey(organization?.id, id) });
      queryClient.invalidateQueries({ queryKey: listKey(organization?.id) });
    },
  });
}

export const useSaveStaffing = (id) =>
  useEngagementMutation(id, (staffing) => saveStaffing(id, staffing));
export const useSaveOutsourcing = (id) =>
  useEngagementMutation(id, (body) => saveOutsourcing(id, body));
